import React from 'react';

function featuredImage(props) {
  const {
    image,
    imageSize,
    imageSizeFull
  } = props;

  let imgTag = '';
  let srcset = props.srcset && props.srcset[imageSize] ? props.srcset[imageSize] : '';
  let size = imageSize;
  if( !image[0].media_details.sizes[imageSize] ){
    size = 'full';
  }
  if (image && image[0].media_details && image[0].media_details.sizes[size]) {
    imgTag = <img src={image[0].media_details.sizes[size].source_url} srcSet={srcset} alt={image[0].title.rendered}></img>;
  }

  return imgTag;
}

export default featuredImage;